import http from './http';

// 上报身份证读卡器状态
export const reportIDCardReaderStatus = (data) => {
  return http({
    method: 'POST',
    url: '/identity-card-reader/status',
    data,
  });
};

// 获取系统时间
export const getSystemTimeStamp = () => {
  return http({
    method: 'GET',
    url: '/sys/getCurrentTimestamp',
  });
};

// 获取系统配置
export const getSystemConfig = () => {
  return http({
    method: 'GET',
    url: '/sys-running-board/sys/config',
  });
};

// 系统看板pms单店所有系统详情
export const getSystemDetail = () => {
  return http({
    method: 'GET',
    url: '/sys-running-board/shop/all-system/detail',
  });
};
